import api from './api'

let vueGlobalPlugin = {}
vueGlobalPlugin.install = (Vue, options) => {
  // 注入组件
  Vue.mixin({
    methods: {
      resetData() {
        Object.assign(this.$data, this.$options.data())
      }
    },
    mounted() {
      const settings = this.$options.settings
      if (settings && settings.resetData) {
        this.$events.on(this.$route.name, () => {
          // Object.assign(this.$data, this.$options.data())
          this.resetData()
        })
      }
    },
    beforeDestroy() {
      const settings = this.$options.settings
      if (settings && settings.resetData) {
        this.$events.off(this.$route.name)
      }
    }
  })
  Object.defineProperty(Vue.prototype, '$api', {value: api})
}

export default vueGlobalPlugin



// WEBPACK FOOTER //
// ./src/services/GlobalPlugin.js